export const CHECKOUT_URL = 'https://conduca-infantil.impultienda.ar/checkout'

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/3gXR6LRLjjrXzuhtsCi47K/mockuo.png'

export const prices = {
  before: '$47.990',
  now: '$17.990',
  saving: '$30.000',
}

export const productPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/fVbKSNDTsReNXge89ntebd/Captura_de_pantalla_2026-10-05_a_la(s)_11.17.25_p._m..png',
    tag: 'Guía principal',
    title: 'Suelo Pélvico Fuerte +40',
    desc: 'De entender qué está pasando a aprender cómo trabajarlo. Respiración, relajación, activación, coordinación y rutinas progresivas.',
    alt: 'Portada de la guía Suelo Pélvico Fuerte +40: guía visual para mejorar el control, la coordinación y la fuerza desde casa.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xzj2eLyT2nCuzkxt77CU4s/Captura_de_pantalla_2026-10-05_a_la(s)_11.19.18_p._m..png',
    tag: 'Guía principal',
    title: 'Dentro vas a trabajar',
    desc: 'Respiración y relajación, activación y control, coordinación, fuerza y movimiento, aplicación en la vida real y rutinas progresivas.',
    alt: 'Página de ejercicio: Respiración 360°. Posición, movimiento en cuatro pasos y objetivo de relajar la musculatura pélvica.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/a99LWQALSfNBTMzZhKMewW/Captura_de_pantalla_2026-10-05_a_la(s)_11.18.37_p._m..png',
    tag: 'Bono 1',
    title: 'Vejiga y escapes +40',
    desc: 'Para entender mejor cuándo aparecen tus síntomas: escapes, urgencia, señales de la vejiga y hábitos que influyen.',
    alt: 'Página del Bono 1: Tu vejiga también responde a tus hábitos. Líquidos, cafeína, estreñimiento, tos y hábitos cotidianos.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9Jy9m1HyW9PUYf4GvmPzP2/Captura_de_pantalla_2026-10-05_a_la(s)_11.17.43_p._m..png',
    tag: 'Bono 2',
    title: 'Hábitos para cuidar tu suelo pélvico',
    desc: 'Porque lo que hacés durante el día también importa: baño, estreñimiento, respiración, cargas y esfuerzos cotidianos.',
    alt: 'Página: ¿Por qué puede cambiar tu suelo pélvico? Seis factores como embarazos, cambios hormonales, estreñimiento, tos y cargas.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uMjfsZSdBH1UGAsSeC4RWc/Captura_de_pantalla_2026-10-05_a_la(s)_11.20.30_p._m..png',
    tag: 'Bono 3',
    title: 'Cambios +40 y tu suelo pélvico',
    desc: 'Para comprender mejor esta nueva etapa: cambios hormonales, tejidos de la zona íntima y por qué no siempre se trata de “fortalecer más”.',
    alt: 'Página del Bono 3: Perimenopausia, menopausia y zona íntima. Sequedad, sensibilidad, irritación y cambios en los tejidos.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rSQxcnKMmgEXLEPuc253yU/Captura_de_pantalla_2026-10-05_a_la(s)_11.21.16_p._m..png',
    tag: 'Bono 4',
    title: 'Mi diario de síntomas y desencadenantes',
    desc: 'Para dejar de adivinar y empezar a observar patrones: cuándo aparecen, qué estabas haciendo y qué se repite.',
    alt: 'Página del Bono 4: Registro de escapes, ¿cuándo ocurren? Tabla por día, hora, actividad, intensidad y notas.',
  },
]

export const needs = [
  {
    title: 'RELAJAR',
    desc: 'cuando existe demasiada tensión.',
    image: 'https://cdn.magicpatterns.com/uploads/1MazaSXwa8vTqR8nDXqGuF/image.png',
    alt: 'Mujer de unos 50 años sentada sobre una colchoneta, respirando profundamente con los ojos cerrados.',
  },
  {
    title: 'ACTIVAR',
    desc: 'cuando cuesta sentir o contraer correctamente.',
    image: 'https://cdn.magicpatterns.com/uploads/reL92vDTK6c8k5bysdbTNA/image.png',
    alt: 'Mujer recostada sobre almohadones, con las manos en la zona baja del abdomen, concentrada en sentir la pelvis.',
  },
  {
    title: 'COORDINAR',
    desc: 'cuando respiración, esfuerzo y suelo pélvico no trabajan juntos.',
    image: 'https://cdn.magicpatterns.com/uploads/8EtwMJKeDQn6Z4ETf8c64t/image.png',
    alt: 'Mujer sentada en la colchoneta realizando una torsión suave mientras respira.',
  },
  {
    title: 'FORTALECER',
    desc: 'cuando necesitás progresar hacia más control y movimiento.',
    image: 'https://cdn.magicpatterns.com/uploads/vZhjzLyXJWPegzfS8x6WGb/image.png',
    alt: 'Mujer realizando una sentadilla asistida apoyada en el respaldo de una silla.',
  },
]

export const steps = ['Respirá y relajá', 'Sentí', 'Activá', 'Coordiná', 'Movete y progresá']

export const pillars = ['Respiración', 'Relajación', 'Activación', 'Control', 'Fuerza', 'Coordinación']

export const guides = [
  {
    title: 'ENTENDÉ QUÉ ESTÁS TRABAJANDO',
    subtitle: 'Antes de fortalecer, necesitás conocer tu cuerpo.',
    desc: 'Aprendé qué es el suelo pélvico, qué funciones cumple y por qué no todas las mujeres necesitan exactamente lo mismo. Vas a entender la diferencia entre dificultad para activar, exceso de tensión y problemas de coordinación.',
  },
  {
    title: 'RESPIRÁ Y APRENDÉ A RELAJAR',
    subtitle: 'Fortalecer no significa mantener todo contraído.',
    desc: 'Empezá con respiración 360°, percepción corporal y relajación para aprender a reconocer cómo responde la musculatura. Porque para activar correctamente también necesitás poder relajar.',
  },
  {
    title: 'APRENDÉ A ACTIVAR Y COORDINAR',
    subtitle: 'Ahora empezás a trabajar el control.',
    desc: 'Aprendé cómo realizar una activación suave, cómo comprobar tu técnica y cómo coordinar el suelo pélvico con la respiración. Sin empezar haciendo ejercicios avanzados que todavía no necesitás.',
  },
  {
    title: 'LLEVÁ EL CONTROL AL MOVIMIENTO',
    subtitle: 'Tu suelo pélvico también trabaja cuando te movés.',
    desc: 'Progresá hacia ejercicios como balanceo de pelvis, elevación de rodilla, puente, levantarte de una silla y sentadilla asistida. Todo explicado visualmente y paso a paso.',
  },
  {
    title: 'APLICÁ TODO A TU VIDA REAL',
    subtitle: 'Porque el objetivo no es entrenar solamente acostada.',
    desc: 'Aprendé cómo prepararte antes de determinados esfuerzos y elegí rutinas según lo que necesites trabajar ese día.',
  },
]

// Add an `image` URL to any bonus to show a real page preview inside its block.
export const bonuses: { title: string; lead: string; desc: string; image?: string }[] = [
  {
    title: 'VEJIGA Y ESCAPES +40',
    lead: 'Para entender mejor cuándo y cómo aparecen tus síntomas.',
    desc: 'Observá situaciones como escapes durante esfuerzos, ganas repentinas de orinar y hábitos relacionados con tu vejiga.',
  },
  {
    title: 'HÁBITOS PARA CUIDAR TU SUELO PÉLVICO',
    lead: 'Para cuidar la zona también fuera de las rutinas.',
    desc: 'Baño, estreñimiento, respiración, cargas y pequeños esfuerzos cotidianos.',
  },
  {
    title: 'CAMBIOS +40 Y TU SUELO PÉLVICO',
    lead: 'Para entender por qué tu cuerpo puede sentirse diferente en esta etapa.',
    desc: 'Cambios hormonales, tejidos de la zona íntima, tensión, activación y adaptación después de los 40.',
  },
  {
    title: 'MI DIARIO DE SÍNTOMAS Y DESENCADENANTES',
    lead: 'Para descubrir qué situaciones se repiten.',
    desc: 'Registrá escapes, urgencia, horarios, actividades y situaciones para conocer mejor tus propios patrones.',
  },
]

export const outcomes = [
  'Qué trabajar primero.',
  'Cómo realizar cada ejercicio.',
  'Cuándo avanzar.',
  'Cuándo reducir la intensidad.',
  'Cuándo priorizar relajación.',
  'Cómo llevar lo aprendido a movimientos cotidianos.',
  'Qué señales conviene consultar con un profesional.',
]

export const faqs = [
  {
    q: '¿Para quién está pensado?',
    a: 'Está pensado especialmente para mujeres +40 que quieren conocer mejor su suelo pélvico y aprender a trabajar respiración, relajación, activación, control, coordinación y fuerza de forma progresiva desde casa.',
  },
  {
    q: '¿Sirve si tengo pequeños escapes al toser, estornudar o hacer fuerza?',
    a: 'La guía incluye trabajo relacionado con control, coordinación y preparación antes de determinados esfuerzos. Los escapes pueden tener diferentes causas, por lo que ante síntomas frecuentes, importantes o que empeoran también es recomendable realizar una valoración profesional.',
  },
  {
    q: '¿Y si siento ganas repentinas de ir al baño?',
    a: 'El material incluye recursos para observar las señales y patrones de tu vejiga. La urgencia urinaria puede tener distintas causas, por lo que la guía no reemplaza una evaluación profesional cuando sea necesaria.',
  },
  {
    q: '¿Son solamente ejercicios de Kegel?',
    a: 'No. El programa trabaja respiración, relajación, percepción, activación, coordinación, fuerza, movimiento y aplicación en situaciones cotidianas.',
  },
  {
    q: '¿Tengo que saber activar mi suelo pélvico antes de empezar?',
    a: 'No. La guía comienza desde las bases para ayudarte a aprender a sentir y reconocer la activación antes de progresar.',
  },
  {
    q: '¿Necesito experiencia haciendo ejercicio?',
    a: 'No. Los movimientos empiezan de forma simple y aumentan progresivamente según control y comodidad.',
  },
  {
    q: '¿Necesito equipamiento?',
    a: 'La mayoría del trabajo puede realizarse en casa con elementos cotidianos como una silla o una colchoneta.',
  },
  {
    q: '¿Tengo que hacer todos los ejercicios todos los días?',
    a: 'No. La guía incluye diferentes opciones para que puedas elegir qué trabajar y progresar sin convertirlo en una rutina interminable.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto 100% digital.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra obtenés acceso al material digital para comenzar a utilizarlo.',
  },
  {
    q: '¿Puedo verlo desde el celular o tablet?',
    a: 'Sí. El contenido está diseñado de forma visual para que puedas consultarlo desde celular, tablet o computadora.',
  },
  {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. También podés imprimir las páginas que quieras utilizar en papel.',
  },
  {
    q: '¿Tengo que pagar una mensualidad?',
    a: 'No. Es un único pago.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía para conocer el producto y decidir si es para vos.',
  },
  {
    q: '¿Cuándo debería consultar a un profesional?',
    a: 'Si aparece dolor importante, sangre o ardor al orinar, dificultad para vaciar la vejiga, sensación marcada de pesadez o bulto vaginal, cambios repentinos, síntomas que empeoran o cualquier situación que te preocupe, buscá una valoración profesional.',
  },
]

export const costs = [
  ['Seguir haciendo contracciones al azar', 'No saber si realmente estás activando correctamente.'],
  ['Buscar ejercicios diferentes cada semana', 'Empezar una cosa nueva sin saber qué debería venir después.'],
  ['Pensar que todo se soluciona “apretando más”', 'Ignorar que también necesitás aprender a relajar y coordinar.'],
  ['No prestar atención a cuándo aparecen tus síntomas', 'Perder información que puede ayudarte a entender mejor tus patrones.'],
  ['Evitar determinados movimientos por inseguridad', 'Empezar a sentir que el problema condiciona cada vez más tu día a día.'],
  ['No saber cómo progresar', 'Repetir siempre lo mismo sin tener un recorrido claro.'],
]

export const finalPath = ['Respirar', 'Relajar', 'Sentir', 'Activar', 'Coordinar', 'Moverte', 'Progresar']
